import { render, staticRenderFns } from "./BookingListSimple.vue?vue&type=template&id=55718cf8"
import script from "./BookingListSimple.vue?vue&type=script&lang=js"
export * from "./BookingListSimple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports